// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Aura Operations API
 * API to manage aura-operations
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DbOperationStatusType } from './DbOperationStatusType';
import {
  DbOperationStatusTypeFromJSON,
  DbOperationStatusTypeFromJSONTyped,
  DbOperationStatusTypeToJSON,
  DbOperationStatusTypeToJSONTyped,
} from './DbOperationStatusType';

/**
 *
 * @export
 * @interface HandlerBaseResponse
 */
export interface HandlerBaseResponse {
  /**
   *
   * @type {string}
   * @memberof HandlerBaseResponse
   */
  id?: string;
  /**
   *
   * @type {DbOperationStatusType}
   * @memberof HandlerBaseResponse
   */
  status?: DbOperationStatusType;
  /**
   *
   * @type {string}
   * @memberof HandlerBaseResponse
   */
  traceUrl?: string;
}

/**
 * Check if a given object implements the HandlerBaseResponse interface.
 */
export function instanceOfHandlerBaseResponse(
  value: object,
): value is HandlerBaseResponse {
  return true;
}

export function HandlerBaseResponseFromJSON(json: any): HandlerBaseResponse {
  return HandlerBaseResponseFromJSONTyped(json, false);
}

export function HandlerBaseResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): HandlerBaseResponse {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    status:
      json['status'] == null
        ? undefined
        : DbOperationStatusTypeFromJSON(json['status']),
    traceUrl: json['trace_url'] == null ? undefined : json['trace_url'],
  };
}

export function HandlerBaseResponseToJSON(json: any): HandlerBaseResponse {
  return HandlerBaseResponseToJSONTyped(json, false);
}

export function HandlerBaseResponseToJSONTyped(
  value?: HandlerBaseResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    id: value['id'],
    status: DbOperationStatusTypeToJSON(value['status']),
    trace_url: value['traceUrl'],
  };
}
